import { useMutation, useQueryClient } from '@tanstack/react-query';
import { toast } from 'sonner';
import { assessmentItemExchangeApi } from '../../services/assessmentItemExchangeApi';
import { assessmentItemExchangeKeys } from './useGetAssessmentItemExchange';

export function useDeleteAssessmentItemExchange() {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: (id: string) => assessmentItemExchangeApi.deleteAssessmentItemExchange(id),
    onSuccess: (response) => {
      if (response.isSuccess) {
        toast.success('Successfully deleted assessment item exchange');
        queryClient.invalidateQueries({ queryKey: assessmentItemExchangeKeys.all });
      } else {
        toast.error(`Error: ${response.errorMessage || 'Failed to delete assessment item exchange'}`);
      }
    },
    onError: (error: Error) => {
      toast.error(`Error: ${error.message || 'Failed to delete assessment item exchange'}`);
    },
  });
}
